import { safeApiRequest } from './apiClient';

/**
 * Sipariş listesi
 */
export const fetchSiparisler = async ({ durum, tab, arama, sayfa = 1, limit = 20, randevuIds, servisKaydiId } = {}) => {
  const query = { sayfa, limit };
  if (durum) query.durum = durum;
  if (tab) query.tab = tab;
  if (arama && arama.trim()) query.arama = arama.trim();
  if (servisKaydiId) query.servisKaydiId = servisKaydiId;
  if (randevuIds && Array.isArray(randevuIds) && randevuIds.length > 0) {
    query.randevuIds = randevuIds.join(',');
  } else if (randevuIds && typeof randevuIds === 'string') {
    query.randevuIds = randevuIds;
  }

  const response = await safeApiRequest('/api/siparisler', {
    method: 'GET',
    query,
    skipCsrf: true,
  });
  return response;
};

/**
 * Garanti siparişi için uygun randevuları listele
 */
export const fetchGarantiRandevulari = async ({ arama, sayfa = 1, limit = 20 } = {}) => {
  const query = { sayfa, limit };
  if (arama && arama.trim()) query.arama = arama.trim();

  const response = await safeApiRequest('/api/siparisler/garanti-randevulari', {
    method: 'GET',
    query,
    skipCsrf: true,
  });
  return response;
};

/**
 * Garanti siparişi için uygun servis kayıtlarını listele (garantiDurumu=true)
 */
export const fetchGarantiServisKayitlari = async ({ arama, sayfa = 1, limit = 20 } = {}) => {
  const query = { sayfa, limit };
  if (arama && arama.trim()) query.arama = arama.trim();

  const response = await safeApiRequest('/api/siparisler/garanti-servis-kayitlari', {
    method: 'GET',
    query,
    skipCsrf: true,
  });
  return response;
};

/** Doğrudan sipariş — açık servis kayıtları */
export const fetchAcikServisKayitlari = async ({ arama, sayfa = 1, limit = 20 } = {}) => {
  const query = { sayfa, limit };
  if (arama && arama.trim()) query.arama = arama.trim();

  const response = await safeApiRequest('/api/siparisler/acik-servis-kayitlari', {
    method: 'GET',
    query,
    skipCsrf: true,
  });
  return response;
};

/**
 * Sipariş detayı
 */
export const fetchSiparisDetay = async (id) => {
  const response = await safeApiRequest(`/api/siparisler/${id}`, {
    method: 'GET',
    skipCsrf: true,
  });
  return response;
};

/**
 * Sipariş oluştur
 * @param {Object} payload - garantiDahilinde, istekPozisyonlari, not, randevuId (opsiyonel), teslimatAdresi (opsiyonel - farklı adres için)
 * @param {File[]|null} photoFiles - varsa multipart (max 8)
 */
export const createSiparis = async (payload, photoFiles = null) => {
  const files = Array.isArray(photoFiles) ? photoFiles.filter(Boolean).slice(0, 8) : [];
  if (files.length > 0) {
    const fd = new FormData();
    fd.append('garantiDahilinde', String(!!payload.garantiDahilinde));
    fd.append('konsinye', String(!!payload.konsinye));
    fd.append('istekPozisyonlari', JSON.stringify(payload.istekPozisyonlari || []));
    if (payload.not) fd.append('not', String(payload.not));
    if (payload.teslimatAdresi) fd.append('teslimatAdresi', String(payload.teslimatAdresi));
    if (payload.servisKaydiId) fd.append('servisKaydiId', String(payload.servisKaydiId));
    if (payload.musteriId) fd.append('musteriId', String(payload.musteriId));
    if (payload.cihazId) fd.append('cihazId', String(payload.cihazId));
    if (payload.randevuId) fd.append('randevuId', String(payload.randevuId));
    files.forEach((f) => fd.append('photos', f));
    const response = await safeApiRequest('/api/siparisler', {
      method: 'POST',
      body: fd,
    });
    return response;
  }
  const response = await safeApiRequest('/api/siparisler', {
    method: 'POST',
    body: payload,
  });
  return response;
};

/**
 * Sekme rozet sayıları
 */
export const fetchSiparisSekmeSayilari = async () => {
  return safeApiRequest('/api/siparisler/sekme-sayilari', { method: 'GET', skipCsrf: true });
};

/**
 * Sipariş onayla (onayPozisyonlari ile ürün silme/adet değiştirme yapılabilir)
 */
export const onaylaSiparis = async (id, { faturaBilgisi, onayPozisyonlari } = {}) => {
  const body = {};
  if (faturaBilgisi !== undefined) body.faturaBilgisi = faturaBilgisi;
  if (onayPozisyonlari !== undefined) body.onayPozisyonlari = onayPozisyonlari;
  const response = await safeApiRequest(`/api/siparisler/${id}/onayla`, {
    method: 'PATCH',
    body,
  });
  return response;
};

/**
 * Sipariş fatura bilgisi gir (Fatura Bekleyen sekmesi için)
 */
export const siparisFaturaGir = async (id, faturaBilgisi) => {
  const response = await safeApiRequest(`/api/siparisler/${id}/fatura`, {
    method: 'PATCH',
    body: { faturaBilgisi },
  });
  return response;
};

/**
 * Sipariş iptal et
 */
export const iptalSiparis = async (id) => {
  const response = await safeApiRequest(`/api/siparisler/${id}/iptal`, {
    method: 'PATCH',
    body: {},
  });
  return response;
};

/**
 * Sipariş kargo bilgisi gir
 */
export const siparisKargoGir = async (id, { kargoFirmasi, kargoTakipNo }) => {
  const response = await safeApiRequest(`/api/siparisler/${id}/kargo`, {
    method: 'PATCH',
    body: { kargoFirmasi, kargoTakipNo },
  });
  return response;
};

/**
 * Sipariş kargo teslim alındı (Teknik servis paneli)
 */
export const siparisKargoTeslimAl = async (id) => {
  const response = await safeApiRequest(`/api/siparisler/${id}/kargo-teslim-al`, {
    method: 'PATCH',
    body: {},
  });
  return response;
};

/**
 * Teknisyen siparişini onayla (TeknisyenOnayBekliyor → OnayBekliyor)
 */
export const teknisyenOnaylaSiparis = async (id) => {
  const response = await safeApiRequest(`/api/siparisler/${id}/teknisyen-onayla`, {
    method: 'PATCH',
    body: {},
  });
  return response;
};

/**
 * Teknisyen siparişini iptal et
 */
export const teknisyenIptalSiparis = async (id) => {
  const response = await safeApiRequest(`/api/siparisler/${id}/teknisyen-iptal`, {
    method: 'PATCH',
    body: {},
  });
  return response;
};
